import { createSlice } from '@reduxjs/toolkit';
import { returnUpdatedChargerList } from '../../Utils/charging-point';

const initialChargersState = { list: [], error: false };

const chargingPointsSlice = createSlice({
  name: 'chargingPoints',
  initialState: initialChargersState,
  reducers: {
    setChargingPoints: (state, action) => {
      const { list, error } = action.payload;
      if (list) {
        state.list = list;
      }
      if (error) {
        state.error = error;
      }
    },
    resetChargingPoints: (state) => {
      state.list = [];
    },
    updateOCPPChargingPoints: (state, action) => {
      const { data } = action.payload;
      if (data) {
        const chargers = [...state.list];
        if (chargers.length) {
          state.list = returnUpdatedChargerList(chargers, data);
        }
      }
    },
    setIsButtonLoadingForId: (state, action) => {
      const chargers = [...state.list];

      state.list = returnUpdatedChargerList(chargers, action.payload);
    }
  }
});

export const {
  setChargingPoints,
  resetChargingPoints,
  updateOCPPChargingPoints,
  setIsButtonLoadingForId
} = chargingPointsSlice.actions;

export default chargingPointsSlice.reducer;
